import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const InvoiceApprovedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SUNRUN_INVOICE_APPROVED),
  projectId: z.number(),
  reason: z.enum([
    "INVOICE_REJECTED_PRICING",
    "INVOICE_REJECTED_QUANTITY",
    "INVOICE_REJECTED_SOW",
    "INVOICE_REJECTED_OTHER",
  ]),
});

export type InvoiceApprovedTaskAttempt = z.infer<typeof InvoiceApprovedTaskAttemptSchema>;
